import Component from './AccountDashboard'
import { withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    'app-AccountDashboard': {
      dashboard_return_text: void
      dashboard_customer_no: void
      dashboard_log_out: void
      dashboard_order_info_text: void
      dashboard_help_and_service: void
      dashboard_payback_program_text: void
      dashboard_payback_program: void
      dashboard_log_in_as: void
      dashboard_my_account: void
      dashboard_orders: void
      dashboard_my_data: void
      dashboard_addresses: void
      dashboard_returns: {
        RETURNS: any
      }
      dashboard_online_service_2: void
      dashboard_online_service_3: void
      dashboard_online_service_4: void
      dashboard_sidebar_image1: {
        IMAGE: string
      }
      dashboard_sidebar_image2: {
        IMAGE: string
      }
      dashboard_wishlist: void
      dashboard_navigation_my_orders: void
    }
  }
}

export default withTranslations(Component, () =>
  useStaticQuery(graphql`
    query app_AccountDashboard_translations {
      dashboard_return_text: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_return_text"
      )
      dashboard_customer_no: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_customer_no"
      )
      dashboard_log_out: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_log_out"
      )
      dashboard_order_info_text: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_order_info_text"
      )
      dashboard_help_and_service: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_help_and_service"
      )
      dashboard_payback_program_text: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_payback_program_text"
      )
      dashboard_payback_program: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_payback_program"
      )
      dashboard_log_in_as: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_log_in_as"
      )
      dashboard_my_account: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_my_account"
      )
      dashboard_orders: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_orders"
      )
      dashboard_my_data: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_my_data"
      )
      dashboard_addresses: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_addresses"
      )
      dashboard_returns: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_returns"
      )
      dashboard_online_service_2: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_online_service_2"
      )
      dashboard_online_service_3: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_online_service_3"
      )
      dashboard_online_service_4: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_online_service_4"
      )
      dashboard_sidebar_image1: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_sidebar_image1"
      )
      dashboard_sidebar_image2: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_sidebar_image2"
      )
      dashboard_wishlist: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_wishlist"
      )
      dashboard_navigation_my_orders: snippet(
        group: "app-AccountDashboard"
        name: "dashboard_navigation_my_orders"
      )
    }
  `)
)
